<template>
  <div class="position-translate-center">
    <div class="col-auto">
      <div class="clearfix">
        <h1 class="float-start display-3 me-4">404</h1>
        <h4 class="pt-3">ページを表示できません</h4>
        <p class="text-medium-emphasis">The page you are looking for was target resource not found.</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ErrorNotFound",
}
</script>
